import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://uloearxysiazommdmfpn.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVsb2Vhcnh5c2lhem9tbWRtZnBuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgyOTE5MDAsImV4cCI6MjA5Mzg2NzkwMH0.mLHuh2mSoWLRPJPCqkcJ64y3YeaY3wvJn_nMydb3MOs';

// Capture the hash BEFORE createClient runs — Supabase clears it during init
export const initialLocationHash = window.location.hash;

// detectSessionInUrl:false — we manually call exchangeCodeForSession in App.js
// so we control exactly when the PKCE code is exchanged.
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    flowType: 'pkce',
    detectSessionInUrl: false,
  },
});